import { Application, Functionality } from '@frontend/functionality/types';

/** Keep only Nivaliz functionalities for the mobile-nivaliz app surface. */
export function filterNivalizFunctionalities(functionalities: Functionality[]): Functionality[] {
    return functionalities.filter((f) => f.application === Application.NIVALIZ);
}
